<template>
  
<div class="col-12 mb-6" >
  <h3 class="page-title">Gendec Rules</h3>
  <br>
  <div class="buttons-area mb-3 text-start">
    <button @click="openNewModal()" class="core-add-btn rounded me-3">Add <i class="icon icon-plus"></i></button>
    <router-link tag="button" class="core-close-btn rounded fw-bold" to="/DAI-Gendec/gendec">
      Back to Gendec
    </router-link>
  </div>
  <div id="myModal" class="modal" >
        <div class="modal-content">
          <div @click="closeModal" class="close text-end">&times;</div>
          <div class="text-start"><h4 class="edit-title mb-0">Edit</h4></div>
          <hr>
          <div class="edit-area">
            <div class="row border-bottom pb-1 pt-2">
              <div class="col-md-2 text-start">
                ID
              </div>
              <div class="col-md-2 text-start">
                {{ this.editData.ID }}
              </div>
            </div> 
            <div class="row border-bottom pb-1 pt-2">
              <div class="col-md-2 text-start">
                Valid Since
              </div>
              <div class="col-md-2 text-start">
                <input class="p-1" id="date" type="date" v-model="editData.VALID_SINCE">
              </div>
              <div class="col-md-2 text-start">
                Valid Until
              </div>
              <div class="col-md-2 text-start">
                <input class="p-1" id="date" type="date" v-model="editData.VALID_UNTIL">
              </div>
            </div> 
            <div class="row border-bottom pb-1 pt-2">
              <div class="col-md-2 text-start">
                Carrier
              </div>
              <div class="col-md-2 text-start">
                <input class="p-1" type="text" v-model="editData.CARRIER">
              </div>
              <div class="col-md-2 text-start">
                Flight No From
              </div>
              <div class="col-md-2 text-start">
                <input class="p-1" type="number" v-model="editData.FNO_FROM">
              </div>
            </div> 
            <div class="row border-bottom pb-1 pt-2">
              <div class="col-md-2 text-start">
                Flight No To
              </div>
              <div class="col-md-2 text-start">
                <input class="p-1" type="number" v-model="editData.FNO_TO">
              </div>
              <div class="col-md-2 text-start">
                Dep Airport
              </div>
              <div class="col-md-2 text-start">
                <input class="p-1" type="text" v-model="editData.DEP_AIRPORT" maxlength="3">
              </div>
            </div> 
            <div class="row border-bottom pb-1 pt-2">
              <div class="col-md-2 text-start">
                Arr Airport
              </div>
              <div class="col-md-2 text-start">
                <input class="p-1" type="text" v-model="editData.ARR_AIRPORT" maxlength="3">
              </div>
              <div class="col-md-2 text-start">
                Dep Country
              </div>
              <div class="col-md-2 text-start">
                <input class="p-1" type="text" v-model="editData.DEP_COUNTRY" maxlength="2">
              </div>
            </div> 
            <div class="row border-bottom pb-1 pt-2">
              <div class="col-md-2 text-start">
                Arr Country
              </div>
              <div class="col-md-2 text-start">
                <input class="p-1" type="text" v-model="editData.ARR_COUNTRY" maxlength="2">
              </div>
              <div class="col-md-2 text-start">
                Distance From Event
              </div>
              <div class="col-md-2 text-start">
                <input class="p-1" type="number" v-model="editData.DIST_FROM_EVENT">
              </div>
            </div> 
            <div class="row border-bottom pb-1 pt-2">
              <div class="col-md-2 text-start">
                Event
              </div>
              <div class="col-md-2 text-start">
                <select style="width: 100px;" class="p-1" v-model="editData.EVENT">
                  <option value="S">STD</option>
                  <option value="A">ATD</option>
                </select>
              </div>
              <div class="col-md-2 text-start">
                I or E
              </div>
              <div class="col-md-2 text-start">
                <select style="width: 100px;" class="p-1" v-model="editData.I_OR_E">
                  <option value="I">Internal</option>
                  <option value="E">External</option>
                </select>
              </div>
            </div> 
            <div class="row border-bottom pb-1 pt-2">
              <div class="col-md-2 text-start">
                Address
              </div>
              <div class="col-md-10 text-start">
                <input class="p-1 w-100" type="text" v-model="editData.ADDRESSES">
              </div>
            </div> 
          </div>
          <div class="modal-footer">
            <div>
              <button @click="saveChanges()" class="btn core-save-btn save-btn rounded">Save <i style="font-size: 14px;" class="icon icon-floppy-disk"></i></button>
            </div>
          </div>
          <div class="employee-status alert d-none" role="alert">
          </div>
          <div class="delete-status alert d-none" role="alert">
          </div>
        </div>
      </div>
  <div>
    <table style="width:1850px;font-family: NunitoBold" border="1" class="table table-bordered table-striped table-scroll core-table table-hover">
        <thead>
          <th>Rule No</th>
          <th>I or E</th>
          <th>Valid Since</th>
          <th>Valid Until</th>
          <th>Carrier</th>
          <th>FNO From</th>
          <th>FNO To</th>
          <th>Dep</th>
          <th>Arr</th>
          <th>Dep Country</th>
          <th>Arr Country</th>
          <th>Distance</th>
          <th>Event</th>
          <th>Address</th>
          <th>Action</th>
        </thead>
        <tr v-for="(item, index) in getData" :key="index" style="padding: 10px;">
          <td>{{ item.ID }}</td>
          <td>{{ item.I_OR_E }}</td>
          <td>{{ item.VALID_SINCE.substring(0,10) }}</td>
          <td>{{ item.VALID_UNTIL.substring(0,10) }}</td>
          <td>{{ item.CARRIER }}</td>
          <td>{{ item.FNO_FROM }}</td>
          <td>{{ item.FNO_TO }}</td>
          <td>{{ item.DEP_AIRPORT }}</td>
          <td>{{ item.ARR_AIRPORT }}</td>
          <td>{{ item.DEP_COUNTRY }}</td>
          <td>{{ item.ARR_COUNTRY }}</td>
          <td>{{ item.DIST_FROM_EVENT }}</td>
          <td>{{ item.EVENT }}</td>
          <td style="max-width: 500px;word-break: break-all;">{{ item.ADDRESSES }}</td>
          <td>
            <button @click="openModal(item)" class="btn core-update-btn me-1" style="color: #fff;">Edit</button>
            <button @click="deleteItem(item.ID)" class="core-close-btn rounded" style="color: #fff;">Delete</button>
          </td>
        </tr>
      </table>
      <div id="delete-modal" class="modal" tabindex="-1">
        <div class="modal-dialog">
          <div class="modal-content pb-0">
            <div class="modal-header">
              <h5 class="modal-title">Delete Rule</h5>
              <button @click="closeDeleteModal" id="publish-close" type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="modal-body">
              <p class="text-start publish-text">You are about to delete the selected Rule. Do you want to continue ?</p>
            </div>
            <div class="modal-footer">
              <button @click="closeDeleteModal" id="publish-close" type="button" class="core-close-btn rounded-1" data-bs-dismiss="modal">No</button>
              <button @click="deleteConfirm" type="button" class="core-save-btn rounded-1">Yes</button>
            </div>
          </div>
        </div>
      </div>
  </div>
</div>
</template>

<script>
import axios from "axios";
import {GlobalFunctionAndStateMixin} from "../../utils/mixins.js";
export default {
  mixins: [GlobalFunctionAndStateMixin],
  name: "GendecRules",
  data(){
    return {
        getData: [],
        deleteID : -99,
        editData: {
          ID: -1,
          I_OR_E : '',
          VALID_SINCE: '',
          VALID_UNTIL: '',
          CARRIER : '',
          FNO_FROM : -1,
          FNO_TO : -1,
          DEP_AIRPORT: '',
          ARR_AIRPORT: '',
          DEP_COUNTRY: '',
          ARR_COUNTRY: '',
          DIST_FROM_EVENT : -1,
          EVENT : '',
          ADDRESSES : '',
          ISDELETED : false,
          WHOPUBLISHED : ''
        }
    }
  },

  created() {
    this.getGendecRules();
    this.assignUserName();
  },

  methods: {
    assignUserName(){
      let userName = JSON.parse(localStorage.getItem("user")).name;
      this.editData.WHOPUBLISHED = userName;
    },
    getGendecRules() {
      axios.get(process.env.VUE_APP_API_URL + "DAI/GendecRules/GetAll")
        .then((response) => {
          this.getData = JSON.parse(response.data.jsondata).ListItems;
          console.log(this.getData);
        })
        this.$forceUpdate();
    },
    deleteItem(id){
      this.deleteID = id;
      let modal = document.getElementById("delete-modal");
      modal.style.display = "block";
    },
    saveChanges(){
      this.getData = [];
      this.editData.VALID_SINCE = this.splitDate(this.editData.VALID_SINCE).formatted_Api;
      this.editData.VALID_UNTIL = this.splitDate(this.editData.VALID_UNTIL).formatted_Api;
      this.editData.FNO_FROM = parseInt(this.editData.FNO_FROM);
      this.editData.FNO_TO = parseInt(this.editData.FNO_TO);
      this.editData.DIST_FROM_EVENT = parseInt(this.editData.DIST_FROM_EVENT);
      console.log(this.editData);
      axios.post(process.env.VUE_APP_API_URL + "DAI/GendecRules/InsertOrUpdate", this.editData)
        .then((response) => {
          console.log(response);
          this.getGendecRules();
        })
        this.closeModal();
    },
    deleteConfirm(){
      axios.post(process.env.VUE_APP_API_URL + "DAI/GendecRules/DeleteById?Id="+ this.deleteID)
        .then((response) => {
          console.log(response);
        })
        this.getGendecRules();
        this.closeDeleteModal();
    },
    closeDeleteModal(){
      let modal = document.getElementById("delete-modal");
      modal.style.display = "none";
    },
        //******** MODAL **********//
    openNewModal(){
        this.editData = {
          ID: -1,
          I_OR_E : '',
          VALID_SINCE: '',
          VALID_UNTIL: '',
          CARRIER : '',
          FNO_FROM : -1,
          FNO_TO : -1,
          DEP_AIRPORT: '',
          ARR_AIRPORT: '',
          DEP_COUNTRY: '',
          ARR_COUNTRY: '',
          DIST_FROM_EVENT : -1,
          EVENT : '',
          ADDRESSES : '',
          ISDELETED : false,
        }
        this.assignUserName();
        let modal = document.getElementById("myModal");
        modal.style.display = "block";
      },
      openModal(item) {
        this.editData.ID = item.ID;
        this.editData.I_OR_E = item.I_OR_E;
        this.editData.VALID_SINCE = item.VALID_SINCE.substring(0,10);
        this.editData.VALID_UNTIL = item.VALID_UNTIL.substring(0,10);
        this.editData.CARRIER = item.CARRIER;
        this.editData.FNO_FROM = item.FNO_FROM;
        this.editData.FNO_TO = item.FNO_TO;
        this.editData.DEP_AIRPORT = item.DEP_AIRPORT;
        this.editData.ARR_AIRPORT = item.ARR_AIRPORT;
        this.editData.ARR_COUNTRY = item.ARR_COUNTRY;
        this.editData.DEP_COUNTRY = item.DEP_COUNTRY;
        this.editData.DIST_FROM_EVENT = item.DIST_FROM_EVENT;
        this.editData.EVENT = item.EVENT;
        this.editData.ADDRESSES = item.ADDRESSES;
        this.editData.ISDELETED = item.ISDELETED;
        console.log(this.editData); 
        let modal = document.getElementById("myModal");
        modal.style.display = "block";
    },
    closeModal() {
      try {
        let modal = document.getElementById("myModal");
        modal.style.display = "none";
        //this.editData = {};
      }
      catch (ex) {
        console.log(ex)
      }
    },
  }

}
</script>


<style scoped>
.page-title{
  margin-top: 100px;
}
td{
  padding: 10px;
}
tr:nth-child(even) {
  background-color: #f2f2f2;
}
.modal {
  display: none; /* Hidden by default */
  position: fixed; /* Stay in place */
  z-index: 1; /* Sit on top */
  padding-top: 100px; /* Location of the box */
  left: 0;
  top: 0;
  width: 100%; /* Full width */
  height: 100%; /* Full height */
  overflow: auto; /* Enable scroll if needed */
  background-color: rgb(0, 0, 0); /* Fallback color */
  background-color: rgba(0, 0, 0, 0.4); /* Black w/ opacity */
}

.modal-content {
  background-color: #fefefe;
  margin: auto;
  padding: 20px;
  border: 1px solid #888;
  width: 80%;
  padding-bottom: 35px;
}

.close {
  color: #aaaaaa;
  float: right;
  font-size: 28px;
  font-weight: bold;
}

.close:hover,
.close:focus {
  color: #000;
  text-decoration: none;
  cursor: pointer;
}
.core-table thead th{
  position: unset;
}
.edit-area{
  font-size: 16px;
}
.save-btn{
  font-size: 18px !important;
}
.publish-text{
  font-size: 15px;
}
</style>